export const DISPLAY_WARNING_TOASTER = 'displayWarningToaster';
export const DISPLAY_ERROR_TOASTER = 'displayErrorToaster';
